import React, { ChangeEvent, CSSProperties, FC, KeyboardEventHandler, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { appWidth } from './CSD/WelcomeCSD';
import screenImage from '../../assets/images/welcome-pattern.png';
import { Heading } from '../components/Heading';
import { Router } from '../router/Router';
import { Input } from '../components/Input';
import { Separator } from '../components/Separator';
import { Button } from '../components/Button';
import { emailChecker } from '../utils/InputChecker';
import { API } from '../utils/API';
import { Loading } from '../components/Loading';
import { ToastBar } from '../components/ToastBar';
import { NotAuthProvider } from '../components/NotAuthProvider';

export const VerificationEmailResend: FC = () => {
  const navigation = useNavigate();

  const styles = {
    root: {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '20px',
    } as CSSProperties,
    bgImage: {
      height: '60%',
      position: 'fixed',
      bottom: 5,
      right: 0,
      zIndex: -1,
    } as CSSProperties,
    mainContainer: {
      width: '100%',
      maxWidth: 400,
      display: 'flex',
      flexDirection: 'column',
      background: 'white',
      borderRadius: '20px',
      padding: '40px 30px',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
    } as CSSProperties,
    form: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    } as CSSProperties,
  };

  const handleBackPressed = () => Router(navigation).goToSignIn();

  const [isLoading, setLoading] = useState<boolean>(false);
  const [isToastVisible, setToastVisible] = useState<boolean>(false);
  const [toastMessage, setToastMessage] = useState<string>('');

  const [email, setEmail] = useState<string>('');
  const [emailError, setEmailError] = useState<boolean>(false);
  const handleEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;
    setEmail(input);

    if (!emailChecker(input)) {
      setEmailError(true);
      return;
    }
    setEmailError(false);
  };

  const buttonDisabled = !email.length || emailError;

  const handleSubmit = () => {
    setLoading(true);
    API.Users.resendEmailVerification(email)
      .then(() => {
        setLoading(false);
        Router(navigation).goToEmailVerification(email);
      })
      .catch((error) => {
        setLoading(false);
        setToastVisible(true);
        setTimeout(() => setToastVisible(false), 3000);
        if (error.data.error_code) {
          setToastMessage(error.message);
          return;
        }
        setToastMessage('Something went wrong');
      });
  };

  const enterKeyPressed = (event: KeyboardEventHandler<HTMLInputElement>) => {
    // @ts-ignore
    const pressed = event.key.toLowerCase();
    if (pressed === 'enter' && !buttonDisabled) {
      handleSubmit();
    }
  };

  return (
    <NotAuthProvider>
      <img className="verification-email-resend-bg-image" style={styles.bgImage} src={screenImage} alt="background" />
      <div style={styles.root}>
        {isLoading && <Loading isVisible={isLoading} />}
        {isToastVisible && <ToastBar isVisible={isToastVisible} message={toastMessage} />}
        <div className="verification-email-resend-container" style={styles.mainContainer}>
          <Heading title="Resend verification email" onBack={handleBackPressed} />
          <div className="verification-email-resend-form" style={styles.form}>
            <Input onError={emailError} onChange={handleEmailChange} errorMessage="Write a valid email." placeholder="Email Address" type="email" onKeyPressed={enterKeyPressed} />
            <Separator size="M" />
            <Button type={buttonDisabled ? 'DISABLED' : 'PRIMARY'} width="100%" title="Submit" onClick={handleSubmit} disabled={buttonDisabled} />
          </div>
        </div>
      </div>
    </NotAuthProvider>
  );
};
